import { render, staticRenderFns } from "./specialoffer.vue?vue&type=template&id=6c3b8974&scoped=true"
import script from "./specialoffer.vue?vue&type=script&lang=js"
export * from "./specialoffer.vue?vue&type=script&lang=js"
import style0 from "./specialoffer.vue?vue&type=style&index=0&id=6c3b8974&lang=less"
import style1 from "./specialoffer.vue?vue&type=style&index=1&id=6c3b8974&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3b8974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c3b8974')) {
      api.createRecord('6c3b8974', component.options)
    } else {
      api.reload('6c3b8974', component.options)
    }
    module.hot.accept("./specialoffer.vue?vue&type=template&id=6c3b8974&scoped=true", function () {
      api.rerender('6c3b8974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketing/activity/specialoffer.vue"
export default component.exports